/* eslint-disable max-len */
export const tableViewsMessages = {
    'TableViews.changeView': 'Change view',
    'TableViews.default': 'Default (all data)',
    'TableViews.delete': 'Delete',
    'TableViews.edit': 'Edit',
    'TableViews.flyout.delete.subtitle':
        'Please select the view you would like to delete.',
    'TableViews.flyout.delete.warning':
        'This action cannot be undone and you will lose all the settings and configurations related with this view.',
    'TableViews.flyout.edit.subtitle':
        'Please update the information of the view currently displayed.',
    'TableViews.flyout.form.accessType': 'Access Type',
    'TableViews.flyout.form.accessType.personal': 'Personal',
    'TableViews.flyout.form.accessType.restricted': 'Restricted',
    'TableViews.flyout.form.accessType.tenant': 'Shared',
    'TableViews.flyout.form.description': 'Description (optional)',
    'TableViews.flyout.form.displayName': 'Name',
    'TableViews.flyout.form.fieldIsRequired': 'This field is required.',
    'TableViews.flyout.form.helperText.personal':
        'Only you can view and edit this view.',
    'TableViews.flyout.form.helperText.restricted':
        'This view is private but can be shared with specific individuals. Only invitees from the owner can use it.',
    'TableViews.flyout.form.helperText.tenant':
        'This view can be seen and edited by all users.',
    'TableViews.flyout.form.nameInUse':
        'This name is already in use. Please choose a different name.',
    'TableViews.flyout.saveAsNewView.subtitle':
        'Please provide the name of the view currently displayed in the dashboard and select the desired access type.',
    'TableViews.flyout.title.delete': 'Delete view',
    'TableViews.flyout.title.edit': 'Edit view',
    'TableViews.flyout.title.saveAsNewView': 'Save as a new view',
    'TableViews.flyout.title.share': 'Share view',
    'TableViews.highRiskApps': 'High risk apps',
    'TableViews.manageViews': 'Manage Views',
    'TableViews.possibleShadowAI': 'Possible shadow AI',
    'TableViews.presetViews': 'Preset views',
    'TableViews.recentlyDiscoveredApps': 'Recently discovered and unclassified',
    'TableViews.resetToDefault': 'Reset to default',
    'TableViews.saaSOpsIntegrations': 'SaaS Ops Integrations',
    'TableViews.saveAsNewView': 'Save as new view',
    'TableViews.savedViews': 'Saved views',
    'TableViews.shadowIT': 'Possible shadow IT',
    'TableViews.share': 'Share',
    'TableViews.unapprovedApps': 'Recently used unapproved apps',
    'TableViews.unclassifiedApps': 'Unclassified apps',
    'TableViews.unsavedChanges': 'There are unsaved changes.',
    'TableViews.userCustomTableView.delete.error':
        '{{displayName}} could not be deleted. Retry your action or contact support for more assistance.',
    'TableViews.userCustomTableView.delete.success':
        '{{displayName}} was successfully deleted.',
    'TableViews.userCustomTableView.edit.error':
        'Changes to {{displayName}} could not be saved. Retry your action or contact support for more assistance.',
    'TableViews.userCustomTableView.edit.success':
        '{{displayName}} was successfully edited.',
    'TableViews.userCustomTableView.saveAsNewView.error':
        'Uh oh! {{displayName}} could not be saved. Retry your action or contact support for more assistance.',
    'TableViews.userCustomTableView.saveAsNewView.success':
        '{{displayName}} was successfully saved.',
    'TableViews.views': 'Views'
};
